import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataUserService {

  constructor() { }
  dataUser(data){
    const id = data;    
    return id;
  }
}
